/**
 * Created by Andrey Popov on 01.10.2026
 *
 * An adventure expedition described by its design folder (see expeditiondesign.js).
 * DESIGN is what the last adventure expeditions share, the expedition's config.json overrides any of it.
 */

AdventureExpedition.DESIGN = {
    workerCutTime: 790,
    customerInfoViewIconScale: 0.95,
    fogAnimationUnits: ["adv3rpcustomermain4"],

    landmark: {
        donorQuest: "adv3rpcustomermain4_1"
    },

    library: [
        [],
        [],
        [],
        ["advsource", "advgenerator0"],
        ["advprize", "expredchest"],
        ["exprunes1", "exprunes2", "exprunes3", "exprunes4", "sidequest1", "sidequest2", "sidequest5", "sidequest6"]
    ],

    // side quest -> progress per collected unit
    sideQuests: {
        sidequest1: 3, sidequest2: 1, sidequest5: 1, sidequest6: 3
    },
    prizeQuests: ["advenergy", "advreward"],
    collections: ["exprunes1", "exprunes2", "exprunes3", "exprunes4"],

    rewards: {
        CheapPack: [
            { energy: 90, hard: 10 },
            { energy: 300, hard: 30 },
            { energy: 300, hard: 30 },
            { energy: 1000, hard: 100 },
            { energy: 1000, hard: 100 }
        ],
        ExpPack: [
            { energy: 300, hard: 50 },
            { energy: 1000, hard: 150 },
            { energy: 1000, hard: 150 },
            { energy: 4000, hard: 2250 },
            { energy: 4000, hard: 2250 }
        ]
    },

    spawner: [
        { code: "advrock", stage: 0, weight: 2 },
        { code: "advlawn", stage: 1 },
        { code: "advlawn", stage: 2 },
        { code: "advsource0", stage: 1 },
        { code: "advsource0", stage: 2 },
        { code: "advsource0", stage: 4 },
        { code: "advflower", stage: 0 },
        { code: "advflower", stage: 1 },
        { code: "advflower", stage: 2 },
        { code: "advpalmtree", stage: 0 },
        { code: "advpalmtree", stage: 2 },
        { code: "advpalmtree", stage: 5 },
        { code: "advsource1", stage: 0 }
    ],

    tools: {
        advenergy: "hands",
        advrush: "hands",
        exprunes: "hands",
        emeralds: "hands",
        berries: "hands",
        advgift: "hands",
        advreward: "hands",
        advchest: "hands",
        advpile: "hands",
        advfireplace: "hands",
        advrock: "axe",
        advlawn: "machete",
        advsource1: "axe",
        advsource0: "machete",
        advflower: "machete",
        advpalmtree: "pickaxe"
    },

    recipes: {
        adv3rpcustomerbridge1_0: [{
            cookingDuration: "5 minutes",
            ingredients: [{
                code: "advproduct0", stage: 1, amount: 2, customInfo: { disablePurchase: true }
            }]
        }],
        adv3rpcustomerbridge2_0: [{
            cookingDuration: "12 minutes",
            ingredients: [{
                code: "advproduct1", stage: 1, amount: 3, customInfo: { disablePurchase: true }
            }]
        }],
        adv3rpcustomerbridge3_0: [{
            cookingDuration: "6 minutes",
            ingredients: [{
                code: "advproduct2", stage: 1, amount: 4, customInfo: { disablePurchase: true }
            }]
        }],
        adv3rpcustomerbridge4_0: [{
            cookingDuration: "14 minutes",
            ingredients: [{
                code: "advproduct3", stage: 1, amount: 5, customInfo: { disablePurchase: true }
            }]
        }],
        adv3rpcustomermain0_0: [{
            cookingDuration: "5 minutes",
            ingredients: [{
                code: "advproduct0", stage: 0, amount: 2, customInfo: { disablePurchase: true }
            }]
        }],
        adv3rpcustomermain1_0: [{
            cookingDuration: "15 minutes",
            ingredients: [{
                code: "advproduct1", stage: 0, amount: 3, customInfo: { disablePurchase: true }
            }]
        }],
        adv3rpcustomermain2_0: [{
            cookingDuration: "1 minutes",
            ingredients: [{
                code: "advproduct2", stage: 0, amount: 4, customInfo: { disablePurchase: true }
            }]
        }],
        adv3rpcustomermain3_0: [{
            cookingDuration: "4 minutes",
            ingredients: [{
                code: "advproduct3", stage: 0, amount: 5, customInfo: { disablePurchase: true }
            }]
        }],
        adv3rpcustomermain4_0: [{
            cookingDuration: "12 minutes",
            ingredients: [{
                code: "advproduct4", stage: 0, amount: 4, customInfo: { disablePurchase: true }
            }]
        }],
        adv3rpproducer0_0: [
            AdventureExpedition.createProducerRecipe("15 minutes", "adv3rpcustomermain0", 0, "fog1", "advlychee", 15, "advblueberry", 15, "advproduct0"),
            AdventureExpedition.createProducerRecipe("11 minutes", "adv3rpcustomermain0", 1, "fog1", "advleaves", 10, "advlog", 10, "advproduct0"),
            AdventureExpedition.createProducerRecipe("3 minutes", "adv3rpcustomerbridge1", 0, "fog2", "advstone", 15, "advgrass", 15, "advproduct0", 1),
            AdventureExpedition.createProducerRecipe("10 minutes", "adv3rpcustomerbridge1", 1, "fog2", "advbanana", 15, "advleaves", 20, "advproduct0", 1)
        ],
        adv3rpproducer1_0: [
            AdventureExpedition.createProducerRecipe("1 minutes", "adv3rpcustomermain1", 0, "fog3", "advleaves", 25, "advgrass", 30, "advproduct1"),
            AdventureExpedition.createProducerRecipe("5 minutes", "adv3rpcustomermain1", 1, "fog3", "advlog", 25, "advleaves", 20, "advproduct1"),
            AdventureExpedition.createProducerRecipe("15 minutes", "adv3rpcustomermain1", 2, "fog3", "advlychee", 20, "advlog", 20, "advproduct1"),
            AdventureExpedition.createProducerRecipe("2 minutes", "adv3rpcustomerbridge2", 0, "fog4", "advleaves", 20, "advbanana", 20, "advproduct1", 1),
            AdventureExpedition.createProducerRecipe("7 minutes", "adv3rpcustomerbridge2", 1, "fog4", "advstone", 15, "advlog", 25, "advproduct1", 1),
            AdventureExpedition.createProducerRecipe("10 minutes", "adv3rpcustomerbridge2", 2, "fog4", "advleaves", 25, "advlog", 25, "advproduct1", 1)
        ],
        adv3rpproducer2_0: [
            AdventureExpedition.createProducerRecipe("14 minutes", "adv3rpcustomermain2", 0, "fog5", "advlychee", 30, "advbanana", 30, "advproduct2"),
            AdventureExpedition.createProducerRecipe("8 minutes", "adv3rpcustomermain2", 1, "fog5", "advleaves", 35, "advlog", 30, "advproduct2"),
            AdventureExpedition.createProducerRecipe("2 minutes", "adv3rpcustomermain2", 2, "fog5", "advblueberry", 30, "advgrass", 35, "advproduct2"),
            AdventureExpedition.createProducerRecipe("6 minutes", "adv3rpcustomermain2", 3, "fog5", "advbanana", 30, "advlog", 40, "advproduct2"),
            AdventureExpedition.createProducerRecipe("8 minutes", "adv3rpcustomerbridge3", 0, "fog6", "advleaves", 45, "advlog", 40, "advproduct2", 1),
            AdventureExpedition.createProducerRecipe("15 minutes", "adv3rpcustomerbridge3", 1, "fog6", "advblueberry", 40, "advlychee", 35, "advproduct2", 1),
            AdventureExpedition.createProducerRecipe("5 minutes", "adv3rpcustomerbridge3", 2, "fog6", "advstone", 45, "advleaves", 50, "advproduct2", 1),
            AdventureExpedition.createProducerRecipe("12 minutes", "adv3rpcustomerbridge3", 3, "fog6", "advleaves", 50, "advgrass", 50, "advproduct2", 1)
        ],
        adv3rpproducer3_0: [
            AdventureExpedition.createProducerRecipe("9 minutes", "adv3rpcustomermain3", 0, "fog7", "advbanana", 50, "advblueberry", 50, "advproduct3"),
            AdventureExpedition.createProducerRecipe("11 minutes", "adv3rpcustomermain3", 1, "fog7", "advleaves", 40, "advlog", 40, "advproduct3"),
            AdventureExpedition.createProducerRecipe("14 minutes", "adv3rpcustomermain3", 2, "fog7", "advgrass", 50, "advleaves", 50, "advproduct3"),
            AdventureExpedition.createProducerRecipe("10 minutes", "adv3rpcustomermain3", 3, "fog7", "advleaves", 40, "advlog", 40, "advproduct3"),
            AdventureExpedition.createProducerRecipe("5 minutes", "adv3rpcustomermain3", 4, "fog7", "advbanana", 35, "advlog", 40, "advproduct3"),
            AdventureExpedition.createProducerRecipe("6 minutes", "adv3rpcustomerbridge4", 0, "fog8", "advgrass", 40, "advleaves", 40, "advproduct3", 1),
            AdventureExpedition.createProducerRecipe("11 minutes", "adv3rpcustomerbridge4", 1, "fog8", "advlog", 40, "advstone", 45, "advproduct3", 1),
            AdventureExpedition.createProducerRecipe("9 minutes", "adv3rpcustomerbridge4", 2, "fog8", "advlychee", 50, "advlog", 40, "advproduct3", 1),
            AdventureExpedition.createProducerRecipe("8 minutes", "adv3rpcustomerbridge4", 3, "fog8", "advblueberry", 45, "advbanana", 40, "advproduct3", 1),
            AdventureExpedition.createProducerRecipe("11 minutes", "adv3rpcustomerbridge4", 4, "fog8", "advgrass", 40, "advleaves", 40, "advproduct3", 1)
        ],
        adv3rpproducer4_0: [
            AdventureExpedition.createProducerRecipe("2 minutes", "adv3rpcustomermain4", 0, "fog9", "advlychee", 40, "advbanana", 25, "advproduct4"),
            AdventureExpedition.createProducerRecipe("5 minutes", "adv3rpcustomermain4", 1, "fog9", "advgrass", 50, "advleaves", 50, "advproduct4"),
            AdventureExpedition.createProducerRecipe("12 minutes", "adv3rpcustomermain4", 2, "fog9", "advleaves", 35, "advlog", 50, "advproduct4"),
            AdventureExpedition.createProducerRecipe("7 minutes", "adv3rpcustomermain4", 3, "fog9", "advstone", 25, "advblueberry", 35, "advproduct4")
        ]
    }
};

AdventureExpedition.registerDesign = function (id, settings) {
    Harvested.CONFIG[id] = this.createExtendedHarvestedConfig();

    cleverapps.tutorial.register(AdvShortTutorialIntroScene(id));

    CustomerRecipes[id] = cleverapps.override(cleverapps.clone(this.CUSTOMER_RECIPES, true), settings.recipes);

    Spawner.PRIZES[id] = settings.spawner;

    Map2d.TILE_MATERIALS[id] = {};

    cleverapps.styles[id] = {
        warehouseTutorialMinimal: this.WAREHOUSE_TUTORIAL_MINIMAL
    };

    this.sourceAnimations[id] = cleverapps.override(cleverapps.clone(this.sourceAnimations.default), settings.tools);
    Object.keys(settings.sideQuests).concat(settings.collections).forEach((code) => {
        this.sourceAnimations[id][code] = "hands";
    });
};

AdventureExpedition.registerDesignQuests = function (id, settings) {
    const dynamic = {};

    Object.keys(settings.sideQuests).forEach((code) => {
        const perCollect = settings.sideQuests[code];
        const questDynamic = { rowCtor: ProgressQuestRow };
        if (perCollect > 1) {
            questDynamic.addProgress = function (quest) {
                quest.progress += perCollect;
            };
        }

        dynamic[code] = {
            priority: 1,
            trigger: { unit: { code, stage: 0 } },
            dynamic: questDynamic,
            quest: { type: Map2d.MINE, unit: { code, stage: 0 }, toMainWorld: true }
        };
    });

    settings.prizeQuests.forEach((code) => {
        dynamic[code] = {
            priority: 1,
            trigger: { unit: { code: "adv3rpcustomerbridge0", stage: 0 } },
            dynamic: {
                rowCtor: ProgressQuestRow,
                getTitle: function () {
                    return Messages.get("Quest.prizeharvested.title");
                },
                getIcon: function () {
                    const icon = Quest.GetUnitIconResource(code);
                    if (icon) {
                        return new cc.Sprite(icon);
                    }
                    return UnitView.getUnitImage({ code, stage: 0 }, { alignAnchorX: true });
                }
            },
            quest: { type: Map2d.PRIZE_HARVESTED, unit: { code }, toMainWorld: true }
        };
    });

    settings.collections.forEach((code) => {
        dynamic[code] = {
            priority: 1,
            trigger: { family: { code } },
            dynamic: {
                rowCtor: StagesQuestRow,
                getTitle: function () {
                    return Messages.get("Quest.mine.title");
                },
                getGoal: function (quest) {
                    return (1 << quest.goal) - 1;
                },
                getIcon: function (unit, quest) {
                    const stage = quest && quest.lastCollectedStage || 0;
                    return UnitView.getUnitImage({ code, stage }, { alignAnchorX: true, customStatic: true });
                },
                addProgress: function (quest, options) {
                    const unit = options.unit || options.affected;
                    quest.lastCollectedStage = unit.stage;
                    quest.progress |= (1 << unit.stage);
                }
            },
            quest: { type: Map2d.MINE, unit: { code } }
        };
    });

    QuestsConfig[`${id}_dynamic`] = dynamic;
};

AdventureExpedition.createDesignSkin = function (id, settings) {
    const fogAnimation = function (unit) {
        if (unit && settings.fogAnimationUnits.includes(unit.code)) {
            return "idle_fog";
        }
    };

    return cleverapps.override(cleverapps.clone(cleverapps.SkinManager.SKINS.adventure_expedition_base, true), {
        bundle: `expedition_${id}`,

        slots: {
            gameAudio: function () {
                return bundles[`expedition_${id}`].urls[`${id}_music`];
            },

            showOneIngredientLeft: function () {
                return true;
            },

            CustomerInfoViewIconScale: function () {
                return settings.customerInfoViewIconScale;
            },

            customerStayFocused: function () {
                return true;
            },

            gameSceneFg: function () {
                if (cleverapps.config.demoMode) {
                    return;
                }
                return bundles[`expedition_${id}`].jsons[`${id}_fg`];
            },

            unitFogAnimation: fogAnimation,

            getPoiAnimation: fogAnimation,

            showFullStateAnimationForPoi: function (unit) {
                if (fogAnimation(unit)) {
                    return true;
                }
            },

            startQuestsEffect: function () {
                return `quests.start.${id}`;
            },

            workerCutTime: function () {
                return settings.workerCutTime;
            },

            lockedFogSoundEffect: function () {
                return bundles[`extra_sound_effects_${id}`].urls.zoom_fog_effect;
            },

            getWorkingAnimation: function (code) {
                return AdventureExpedition.sourceAnimations[id][code];
            },

            getUnitCollectImage: function (options) {
                const unit = options && options.unit;
                if (!unit || unit.code.indexOf("sidequest") !== 0) {
                    return undefined;
                }

                const icon = Quest.GetUnitIconResource(unit.code);
                return icon ? new cc.Sprite(icon) : undefined;
            },

            skipWalkingWorkerAnimationMix: function () {
                return true;
            },

            workerDefaultStepSound: "stone",

            unitsLibraryMinimalLayout: true,

            worker_json: bundles[`merge_${id}`] && bundles[`merge_${id}`].jsons.worker_json
        }
    });
};

ExpeditionDesign.list().filter((design) => design.type === "adventure").forEach((design) => {
    const id = design.id;
    const settings = cleverapps.override(cleverapps.clone(AdventureExpedition.DESIGN, true), design);

    AdventureExpedition.LOCATION_IDS.push(id);
    AdventureExpedition[`register_${id}`] = AdventureExpedition.registerDesign.bind(AdventureExpedition, id, settings);
    AdventureExpedition[`register_${id}_quests`] = AdventureExpedition.registerDesignQuests.bind(AdventureExpedition, id, settings);

    UnitsLibrary.CODES_BY_TAB[id] = settings.library;

    cleverapps.styles.FogTileView[id] = cleverapps.styles.FogTileView.adventure;

    cleverapps.SkinManager.SKINS[`${id}_expedition`] = AdventureExpedition.createDesignSkin(id, settings);

    Object.keys(settings.rewards).forEach((name) => {
        RewardsConfig[id.charAt(0).toUpperCase() + id.slice(1) + name] = settings.rewards[name];
    });

    AchievementsConfig.registerExpedition(id, settings.landmark);
});
